import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledLayout = styled('div')(() => {
  return {
    overflow: 'hidden',
  };
});

export const StyledContainer = styled('main')(() => {
  return {
    width: '100%',
    position: 'relative',
  };
});

export const StyledGrayContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: COLORS.lightGray,
  };
});
